export const LANGUAGES = [
    
    { label: "عربي", code: "ar" },
    { label: "English", code: "en" },
  ];